import { Endpoint, RecordsForPage } from "../mb_constants";

/**
 * 
 * @param {*} page 
 * @param {*} search 
 * @returns 
 */
const MbApi_RestRoomList = async (page, search) => {
    
    try{
        const response = await fetch(
            `${Endpoint}/api/mb/v1/rest_room/list?page=${page}&record_for_page=${RecordsForPage}${search ? `&search=${search}` : ''}`,
            {
                headers: {
                    'jwt': `Bearer ${localStorage.getItem('jwt')}`
                }
            }
        );

        if(response.status == 200){
            const data = await response.json();
            return data;
        }
    }catch(_){
        
    }

    return null;
};

/**
 * 
 * @param {*} body 
 * @returns 
 */
const MbApi_RestRoomCreate = async (body) => {

    const response = await fetch(
        `${Endpoint}/api/mb/v1/rest_room/create`,
        {
            method: "POST",
            headers: {
                'jwt': `Bearer ${localStorage.getItem('jwt')}`,
                'Content-Type': "application/json"
            },
            body: body
        }
    );

    try{
        if(response.status == 201){
            const res = await response.json();
            if(res.Result == "OK"){
                return res.Json;
            }
        }
    }catch(_){

    }

    return false;
};

/**
 * 
 * @param {*} id_rest_room
 * @returns 
 */
const MbApi_RestRoomDelete = async (id_rest_room) => {

    const response = await fetch(
        `${Endpoint}/api/mb/v1/rest_room/delete?id_rest_room=${id_rest_room}`,
        {
            method: "DELETE",
            headers: {
                'jwt': `Bearer ${localStorage.getItem('jwt')}`,
                'Content-Type': "application/json"
            }
        }
    );

    try{
        if(response.status == 200){
            const res = await response.json();
            if(res.Result == "OK"){
                return true;
            }
        }
    }catch(_){

    }

    return false;

};

export {
    MbApi_RestRoomList,
    MbApi_RestRoomCreate,
    MbApi_RestRoomDelete
}